import React from 'react'
import AgTechFadeInView from '../Loading/AgTechFadeInView';
import { ErrorBoundary } from 'react-error-boundary';
import { isDev } from '@agtech/core/utilities/AgTechUtilities';
import { useAgTechWebAppContext } from '../../App/Contexts/AgTechWebAppContext';

const AgTechPageErrorBoundary = (props: { children: JSX.Element }) => {
    const appContext = useAgTechWebAppContext();

    return (
        <ErrorBoundary
            onError={(error, info) => {
                if (isDev()) {
                    appContext.messaging.showError({
                        header: 'Error',
                        details: error.message
                    })
                }

            }}
            FallbackComponent={AgTechPageErrorPage}
        >
            {props.children}
        </ErrorBoundary>
    )
}

const AgTechPageErrorPage = () => {
    return (
        <AgTechFadeInView classes='stretched row-based centered bg-transparent flex'>
            <i className={`fas fa-exclamation bg-red-400 text-white mb-4 h-[32px] w-[32px] rounded-[50%] centered flex`} />
            <h2 className='text-lg font-semibold mb-4 pb-4'>An error occurred within the application.</h2>
            <h3 className='text-plus mb-6'>To restart, please click the button below. If the issue persists, please contact us.</h3>
            <button
                className='button-highlight py-2-half px-6 font-size-large'
                onClick={() => {
                    window.location.href = '/app';
                }}
            >
                Restart Application
            </button>
        </AgTechFadeInView>
    )
}

export default AgTechPageErrorBoundary